import React, {useState} from 'react';
import {useMutation} from '@apollo/react-hooks';

import {useCurrentUserContext} from '../../../../../context/CurrentUserProvider';
import {useMusicKitContext} from '../../../../../context/MusicKitProvider';
import {
  SEND_PHONE_VERIFICATION_CODE_MUTATION,
  VERIFY_CODE_MUTATION,
} from './graphql';

import {loginWithCode as LoginWithCodeData} from './graphql/types/loginWithCode';
import {sendPhoneVerificationCode as SendPhoneResponse} from './graphql/types/sendPhoneVerificationCode';
import {useHistory} from 'react-router';
import {Page} from '../../../../../types';

const Stage = {
  ENTER_PHONE: 1,
  VERIFY_CODE: 2,
};

export function LoginWithPhone() {
  const history = useHistory();

  const [phoneNumber, setPhoneNumber] = useState('');
  const [verificationCode, setVerificationCode] = useState('');
  const [stage, setStage] = useState(Stage.ENTER_PHONE);
  const currentUser = useCurrentUserContext();
  const musicKit = useMusicKitContext();

  const [login, {loading: waitingOnLogin}] = useMutation(
    SEND_PHONE_VERIFICATION_CODE_MUTATION,
    {
      variables: {phoneNumber},

      onCompleted: ({sendPhoneVerificationCode: data}: SendPhoneResponse) => {
        const {errors, sent} = data!;
        if (sent) {
          setStage(Stage.VERIFY_CODE);
        } else if (errors) {
          alert(errors.join('. '));
        }
      },
    },
  );

  const [verifyCode, {loading: waitingToVerifyCode}] = useMutation(
    VERIFY_CODE_MUTATION,
    {
      variables: {verificationCode: verificationCode},
      onCompleted: async ({loginWithCode}: LoginWithCodeData) => {
        const {newAccount, loggedIn} = loginWithCode!;

        if (loggedIn && newAccount) {
          // New user login
          history.push(Page.CreateAccount);
        } else if (loggedIn) {
          // Regular login
          const musicToken = await musicKit!.authorize();
          await currentUser.updateToken(musicToken);
          await currentUser.refresh();
          history.push(Page.Home);
        } else if (!loggedIn) {
          alert('Incorrect Code Entered');
        }
      },
    },
  );

  const enterPhoneNumberMarkup =
    stage === Stage.ENTER_PHONE ? (
      <div>
        <form>
          <input
            value={phoneNumber}
            autoFocus
            onChange={({target}) => setPhoneNumber(target.value)}
            type="text"
            placeholder="Phone Number"
          />
          <div>
            <button onClick={() => login()} disabled={waitingOnLogin}>
              Login
            </button>
          </div>
        </form>
      </div>
    ) : null;

  const verifyCodeMarkup =
    stage === Stage.VERIFY_CODE ? (
      <div>
        <form>
          <input
            value={verificationCode}
            autoFocus
            onChange={({target}) => setVerificationCode(target.value)}
            type="text"
            placeholder="Verification Code"
          />
          <div>
            <button onClick={() => verifyCode()} disabled={waitingToVerifyCode}>
              Verify Phone Number
            </button>
          </div>
        </form>
        <button onClick={() => setStage(Stage.ENTER_PHONE)}>
          Enter another number
        </button>
      </div>
    ) : null;

  return (
    <>
      {enterPhoneNumberMarkup}
      {verifyCodeMarkup}
    </>
  );
}
